var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.71851 1L6.71926 6.75149",
    stroke: "#7E916F",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.71933 6.75126L0.974609 6.74976",
    stroke: "#1375EB",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6557 1.0437C18.6477 1.04671 18.6409 1.04997 18.6354 1.05348C18.6269 1.05799 18.6226 1.06501 18.6226 1.07454L18.6211 6.75382",
    stroke: "#F3801D",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6216 6.75366C18.6204 6.75366 18.6189 6.75366 18.6172 6.75366",
    stroke: "#7EB426",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.72186 6.75433C6.72128 6.75375 6.7204 6.75288 6.71924 6.75171",
    stroke: "#91A080",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.3305 6.7356L18.6211 6.75365",
    stroke: "#75783E",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.72309 14.7022L0.974609 14.7007",
    stroke: "#138495",
    strokeWidth: 0.150425
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.7239 20.4514L6.72314 17.5723",
    stroke: "#00983A",
    strokeWidth: 0.150425
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.71858 1L6.71933 6.75149L0.974609 6.74998V2.5238C1.01723 2.22496 1.10573 1.974 1.24011 1.77093C1.57154 1.26851 2.0534 1.01554 2.68569 1.01203C4.02246 1.00501 5.36676 1.001 6.71858 1Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.71851 1L18.5584 1.0015C18.5834 1.00149 18.6076 1.00912 18.6276 1.02332L18.6555 1.04362C18.6474 1.04663 18.6407 1.04989 18.6351 1.0534C18.6266 1.05791 18.6224 1.06493 18.6224 1.07446L18.6209 6.75374C18.6199 6.75374 18.6186 6.75374 18.6171 6.75374H6.72151C6.72101 6.75324 6.72026 6.75249 6.71926 6.75149L6.71851 1Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.6557 1.0437L24.3305 6.73577L18.6211 6.75382L18.6226 1.07454C18.6226 1.06501 18.6269 1.05799 18.6354 1.05348C18.6409 1.04997 18.6477 1.04671 18.6557 1.0437Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0.974609 6.74976L6.71933 6.75126C6.72033 6.75226 6.72108 6.75302 6.72158 6.75352L6.72309 14.702L0.974609 14.7005V6.74976Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.3303 6.7356L24.3657 6.76117V18.938C24.2323 19.6666 23.8548 20.1372 23.233 20.3498C23.0114 20.426 22.6847 20.4636 22.253 20.4626C19.4506 20.4581 16.6196 20.4538 13.76 20.4498C13.3448 20.4493 12.9236 20.4523 12.4964 20.4588C12.4729 20.4593 12.4528 20.4679 12.4363 20.4844C11.0373 21.8768 9.63336 23.2813 8.22438 24.6978C8.00852 24.9152 7.76408 25.0363 7.45421 24.9904C7.16539 24.9478 6.95254 24.7988 6.81566 24.5436C6.75799 24.4353 6.72866 24.2378 6.72766 23.9509C6.72415 22.7882 6.72289 21.6216 6.7239 20.4513L6.72314 17.5722L9.56467 14.7307C9.57705 14.7183 9.59179 14.7084 9.60805 14.7017C9.62431 14.695 9.64177 14.6916 9.65943 14.6916L18.5571 14.6946C18.5736 14.6946 18.5895 14.688 18.6012 14.6763C18.6129 14.6646 18.6195 14.6487 18.6195 14.6321L18.6172 6.75365C18.6187 6.75365 18.62 6.75365 18.621 6.75365L24.3303 6.7356Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.72309 14.7022V17.5723L6.72384 20.4514C5.52195 20.4584 4.33033 20.4607 3.149 20.4582C2.65661 20.4572 2.30186 20.4186 2.08474 20.3424C1.47602 20.1298 1.10598 19.6584 0.974609 18.9284V14.7007L6.72309 14.7022Z",
    fill: "#00832D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChatIcon);
export default __webpack_public_path__ + "static/media/google-chat-icon.c7961ebf6544f00e311b55bf4db7f809.svg";
export { ForwardRef as ReactComponent };